import { Layout } from '../../components/Layout';
import { PageHead } from '../../components/PageHead';

export function NotFound() {
  return (
    <Layout>
      <PageHead
        title="404 — AuctiSync Help Center"
        description="That article or category couldn't be found."
      />
      <section className="mx-auto max-w-3xl px-6 py-24 text-center">
        <p className="font-mono text-sm tracking-widest" style={{ color: 'var(--text-muted)' }}>
          404
        </p>
        <h1
          className="mt-4 text-4xl font-bold tracking-tight md:text-5xl"
          style={{ color: 'var(--text)' }}
        >
          That article doesn't exist yet.
        </h1>
        <p className="mt-4" style={{ color: 'var(--text-muted)' }}>
          Articles ship with every feature module per the docs-as-DoD discipline.
        </p>
        <p className="mt-6">
          <a
            href="/"
            className="underline-offset-4 hover:underline"
            style={{ color: 'var(--brand-accent)' }}
          >
            ← Back to all categories
          </a>
        </p>
      </section>
    </Layout>
  );
}
